module.exports = {"quoteandbind_lob":["cpp"],"quoteandbind_feature":[],"policycommon_lob":["pa","ho"],"gatewayquoteandbind":"false","phone-validation":["libphonenumber"],"faq":"true","showQuoteStartDateInHeader":true,"fb-sharing":"true","auth-type":"anonymous-user","languageVariant":"EDG_PH","analytics":true,"viewmodel":{"subtreeValidity":{"assumeValid":["edge.capabilities.policycommon.coverage.dto.CoverageDTO"]}},"tracking":{"googleAnalytics":"adapters.googleAnalytics","googleTagManager":"adapters.googleTagManager"}}


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/effective-features!
// module id = 67
// module chunks = 0